import script from "./Contactus.vue?vue&type=script&setup=true&lang=js"
export * from "./Contactus.vue?vue&type=script&setup=true&lang=js"

import "./Contactus.vue?vue&type=style&index=0&id=3a3731b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3731b8"]])

export default __exports__